import React, { useState } from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useActuatorIndices, useActuatorOptions } from './useActuatorOptions'
import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { CheckboxField, TextField } from '@e3dc-react/shell/Elements/InputFields'
import { Select } from '@e3dc-react/shell/Elements/Select'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Actuator } from 'src/Libs/smart-home/models/smart-home.model'
import useModals from '../../Hooks/useModals'

const useStyles = makeStyles()(theme => ({
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}))

export interface ActuatorEditorProps {
  actuators: Actuator[]
  onConfirm: (name: string, type: number, index: number, group: boolean, onClose: () => void) => void
  place: number
  onClose: () => void
}

const ActuatorEditor = ({ place, onClose, actuators, onConfirm }: ActuatorEditorProps): React.ReactElement => {
  const { t } = useCustomTranslation()
  const { openConfirmationModal } = useModals()
  const options = useActuatorOptions()
  const indexOptions = useActuatorIndices(actuators ?? [])
  const [index, setIndex] = useState(indexOptions[0].value)
  const [name, setName] = useState('')
  const [type, setType] = useState<number>(options[0].value)
  const [group, setGroup] = useState(false)
  const { classes } = useStyles()

  return (
    <Dialog
      title={t('homePowerStation.actuatorEditor.title')}
      onClose={() => onClose()}
      place={place}
      actions={{
        primary: {
          name: t('common.add'),
          onClick: () => {
            openConfirmationModal({
              title: t('smartHome.actuators.addTitle'),
              text: t('smartHome.actuators.addText'),
              buttonText: [t('common.cancel'), t('common.ok')],
              onConfirm: () => {
                onConfirm(name, type, index, group, onClose)
              },
            })
          },
        },
        secondary: [
          {
            name: t('common.cancel'),
          },
        ],
      }}
    >
      <Grid container spacing={4} className={classes.container}>
        <Grid item xs={12} md={8}>
          <TextField label={t('smartHome.actuators.name')} value={name} onChange={setName} />
        </Grid>
        <Grid item xs={12} md={4}>
          <CheckboxField label={t('smartHome.actuators.group')} value={group} onChange={setGroup} />
        </Grid>
        <Grid item xs={12} md={8}>
          <Select label={t('smartHome.actuators.type')} value={type} options={options} onChange={setType} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Select label={t('smartHome.actuators.index')} value={index} options={indexOptions} onChange={setIndex} />
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default ActuatorEditor
